import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap'
import DeliveryAddress from './delivery-address';
import OrderSummary from './order-summary';
import OrderDetails from './order-details';
import BackLink from '../../common/back-link/index'
import PageTitle from '../../common/page-title/index'
import InlineCKEditor from '../../common/editor/inline-editor'
import {getOrder} from '../../../actions/orders'
import {loadPageContent} from '../../../actions/content';

import './styles.css'

class ViewOrder extends Component {

  constructor(props) {
    super(props);

    this.pageSlug = 'view-order';
    this.state = {};
  }

  componentWillMount() {
    this.id = +this.props.match.params.id;
    this.props.dispatch(getOrder(this.id));
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <Grid bsClass="container" className="view-order">
        <Row>
          <Col lg={12}>
            <BackLink href="/my-orders#complete"/>
          </Col>
        </Row>
        <PageTitle className="pull-left">View order</PageTitle>
        <Row>
          <Col lg={12}>
            <InlineCKEditor identifier={`${this.pageSlug}_content_text`}
                            onContentSaved={this.handleContentSaved}
                            contents={this.props.contents[`${this.pageSlug}_content_text`]}/>
          </Col>
        </Row>
        <Row>
          <Col sm={8}>
            {this.props.order.attributes && <DeliveryAddress order={this.props.order}/>}
          </Col>
          <Col sm={4}>
            {this.props.order.attributes && <OrderSummary order={this.props.order}/>}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {this.props.order.attributes && <OrderDetails items={this.props.order.attributes['order-details']}/>}
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    order:    state.orders.order,
    fetched:  state.orders.fetched,
    fetching: state.orders.fetching,
    contents: state.content.list
  };
};

export default connect(mapStateToProps)(ViewOrder);



// WEBPACK FOOTER //
// ./src/components/my-orders/view/index.jsx